import { Controller, useForm } from "react-hook-form";
import {
  LiveStakeContainer,
  LiveStakeTitleList,
  StakeForm,
  StakeFormBody,
  StakeFormHeader,
} from "../Stake/styled";
import InputCommon from "../../../../../components/Common/Input";
import { ButtonCommon } from "../../../../../Layout/styled";
import { convertFixed, convertFromWei } from "../../../../../utils/convertNumber";
import { useContext, useEffect, useState } from "react";
import web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import ABI_STAKING from "../../../../../constant/ABI/abiStaking.json";
import toast from "react-hot-toast";
import { ContextProviderWrapper } from "../../../../../components/Context";
import Loading from "../../../../../components/Loading";
import Value from "../../../../../components/Value";

type FormValuesProps = {
  value: string;
};

const LiveUnstake = ({
  displayData,
  clickedId,
  setOpenUnStake,
  userProfile,
  fetchUserProfile,
  fetchPrices,
}: any) => {
  const { theme }: any = useContext(ContextProviderWrapper);
  const Web3 = new web3(window.ethereum);
  const { address }: any = useAppKitAccount();
  const [isLoading, setIsLoading] = useState(false);
  const [amountUnstake, setAmountUnstake] = useState(0);
  const defaultValues = {
    value: "",
  };

  const methods = useForm<FormValuesProps>({
    defaultValues,
    mode: "onChange",
  });

  const { control } = methods;

  const balanceToken = convertFromWei(
    userProfile[clickedId]?.info.amount,
    userProfile[clickedId]?.detailsToken?.decimals
  );

  const handleWithdraw = async () => {
    setIsLoading(true);
    try {
      const contract = new Web3.eth.Contract(
        ABI_STAKING,
        displayData[clickedId - 1]?.contract
      );
      await contract.methods.withdraw(false).send({ from: address })
        .then(async () => {
          await fetchUserProfile();
          await fetchPrices();
          toast.success("Unstake successfully");
          setIsLoading(false);
          setOpenUnStake(false);
        })
        .catch((err: any) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    } catch (error: any) {
      console.log(error);
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  const handleGetAmountUnstake = async () => {
    try {
      const contractProvider = new Web3.eth.Contract(
        ABI_STAKING,
        displayData[clickedId - 1]?.contract
      );
      const result = await contractProvider.methods
        .getUnstakeAmount(address)
        .call();
      setAmountUnstake(
        Number(
          convertFromWei(result, userProfile[clickedId]?.detailsToken.decimals)
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (clickedId > 0) {
      handleGetAmountUnstake();
    }
  }, [clickedId, address]);

  return (
    <LiveStakeContainer>
      <LiveStakeTitleList className={theme}>
        <li>
          <Value value={balanceToken || 0} />
          {displayData[clickedId - 1]?.token0?.name} Locked
        </li>
        <li>
          <Value value={amountUnstake || 0} />
          {displayData[clickedId - 1]?.token0?.name} UnLocked
        </li>
      </LiveStakeTitleList>
      <StakeForm className={theme}>
        <StakeFormHeader className={theme}>
          <p>Amount</p>
          <div>
            <p>Staked: {convertFixed(Number(balanceToken))}</p>
          </div>
        </StakeFormHeader>
        <StakeFormBody className={theme}>
          <Controller
            name="value"
            control={control}
            render={({ field }: any) => (
              <InputCommon
                {...field}
                placeHolder={amountUnstake || 0}
                name="search"
                disabled
                type="number"
              />
            )}
          />
        </StakeFormBody>
      </StakeForm>
      <ButtonCommon
        onClick={() => {
          handleWithdraw();
        }}
        disabled={isLoading || Number(amountUnstake) <= 0}
      >
        <Loading status={isLoading} title="Unstake" />
      </ButtonCommon>
    </LiveStakeContainer>
  );
};

export default LiveUnstake;
